import React, { useContext } from 'react';
import AppContext from '../context';
import { H1 } from '../elements';

export const Header = () => {
  const { dark } = useContext(AppContext);
  return (
    <div
      className='latest-blogs'
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '2rem 0',
      }}
    >
      <H1 style={{ color: dark ? 'white' : 'black' }}>Latest Blogs</H1>
    </div>
  );
};
